export default {
  title: 'Podatki i waluta',
  subtitle: 'Zarządzaj kategoriami podatkowymi używanymi do wyceny pozycji menu.',
};
